import React, { useRef, useEffect } from 'react';

import videoshowroom from '../../assets/videos/videoshowroom.mp4'

function CarrouselShowroom() {
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
        videoRef.current.play().catch(error => {
            console.log("Autoplay fue bloqueado por el navegador:", error);
        });
        }
    }, []);

    return (
        <>
        <div className="fullscreen-carousel">
            <div id="videoCarousel" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
                <div className="carousel-item active">
                <video
                    ref={videoRef}
                    className="d-block"
                    autoPlay
                    muted
                    loop
                    playsInline
                >
                    <source
                    src={videoshowroom}
                    type="video/mp4"
                    />
                </video>
                </div>
            </div>

            
            </div>
        </div>
        </>
    );
}
export default CarrouselShowroom;